import React, { FC } from 'react';
import { StyledArrow, StyledArrowContainer } from 'src/ui/common/atoms/animated-arrow/animated-arrow.styles';

interface IProps {
    bottomPosition: number;
    label?: string;
}

export const AnimatedArrow: FC<IProps> = ({ bottomPosition, label }) => (
    <StyledArrowContainer bottomPosition={bottomPosition}>
        {label && <span>{label}</span>}
        <StyledArrow>
            <span />
            <span />
            <span />
            <span />
        </StyledArrow>
    </StyledArrowContainer>
);
